'use strict';

import BiBaseDataItem from './bi-base-item';

/**
 * Represents the "load started" bi event:
 * http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/14
 *
 * It should be used to monitor the initial application load.
 */
export default class BiLoadStartDataItem extends BiBaseDataItem {
  constructor(sessionId) {
    super(14, sessionId);
  }
}



// WEBPACK FOOTER //
// ./data-items/bi-load-start-item.js